import {
    genericPage,
    getServerSidePropsHelper,
    getMappingEleccions3CatInfo,
    getSlugEleccio,
    getBasePathEleccio
} from 'components/3catinfo/Page';
import __isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, [
        'web',
        process.env.FOLDER_LAYOUTS_3CATINFO,
        'eleccions',
        'eleccions-parlament-catalunya-2017',
        'resultats',
        'final'
    ]);
};

export async function getServerSideProps(context) {
    const basePath = getBasePathEleccio(context?.resolvedUrl);
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    if (__isEmpty(mapping)) {
        return {
            notFound: true
        };
    }

    const path = [...basePath, 'resultats', 'final'];

    const options = {
        slugs: path,
        id: mapping.id
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
